var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "checkboxSelectedTitle"
  }, "Checkbox Selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "checkboxSelectedTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#292929",
    strokeWidth: 0.857142857,
    fill: "#292929",
    x: 0.428571429,
    y: 0.428571429,
    width: 11.1428571,
    height: 11.1428571,
    rx: 2.57142857
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "3.5913887 7.06059844 5.29091893 8.77632144 8.73424584 3.6334643"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelected);
export default __webpack_public_path__ + "static/media/Checkbox_Selected.207248b599ca9b6a7137d1e6cf3a087c.svg";
export { ForwardRef as ReactComponent };